import { CSSTransition, TransitionGroup } from 'react-transition-group'
import { StyledContent } from '@/components/styles'
import { Article } from '@/components'

const Articles = ({ data, articleType }) => {
  return (
    <StyledContent.Articles>
      <TransitionGroup component={null}>
        {data.map(article => {
          const { id } = article
          return (
            <CSSTransition
              in={true}
              key={id}
              timeout={{
                appear: 0,
                enter: 400,
                exit: 0,
              }}
              classNames="on"
            >
              <Article key={id} {...article} articleType={articleType} />
            </CSSTransition>
          )
        })}
      </TransitionGroup>
    </StyledContent.Articles>
  )
}

export default Articles
